import { PAGE_TYPE } from '@amzn/journeys-common';
import type { MCCampaignConfig } from '../../campaign-configs/types';
import { contentSectionConfig } from './content-section';
import { creatorsConfig } from './creators';
import { featuredBrandsLivePreviewConfig } from './live-preview';
import { overviewSectionConfig } from './overview-section';
import { placementsSectionConfig } from './placements-section';
import { publishingConfig } from './publishing';
import { summarySectionConfig } from './summary-section';
import type {
  FeaturedBrandsContent,
  FeaturedBrandsGlobalContent,
  FeaturedBrandsOverviewTableData,
  FeaturedBrandsPlacementTableRowData,
  FeaturedBrandsShareableFieldsMetaMap,
} from './types';
import { featuredBrandsVarSharingConfig } from './var-sharing';

export const featuredBrandsCampaignConfig: MCCampaignConfig<
  FeaturedBrandsContent,
  FeaturedBrandsShareableFieldsMetaMap,
  FeaturedBrandsOverviewTableData,
  FeaturedBrandsPlacementTableRowData,
  FeaturedBrandsGlobalContent
> = {
  campaignsListConfig: {
    getPlatformsArray: () => [
      'Multiplatform',
    ],
  },
  campaignTypeDisplayName: 'Featured Brands (MCC)',
  contentSection: contentSectionConfig,
  /** "Subconfigs" below */
  creators: creatorsConfig,
  hasMultiPlatformFlavors: true,
  isMCC: true,
  isPlatformAgnostic: false,
  livePreview: featuredBrandsLivePreviewConfig,
  overviewSection: overviewSectionConfig,
  pageType: PAGE_TYPE.SEARCH,
  placementsSection: placementsSectionConfig,
  publishing: publishingConfig,
  requiresCBR: true,
  requiresMocar: false,
  summarySection: summarySectionConfig,
  varSharing: featuredBrandsVarSharingConfig,
  varSharingEnabled: true,
};
